import Vue from "vue";
import noty from "./noty.service";

export default {
    async getSettingsAsync(clientId) {
        return (await Vue.http.get(`/api/betconstruct/${clientId}/settings`)).data;
    },
    async saveSettingsAsync(clientId, settings) {
        await Vue.http.post(`/api/betconstruct/${clientId}/settings`, settings);
        noty.success("Settings saved successfully");
    },
    async renameCategory(clientId, provider, oldName, newName, successHandler) {
        const settings = {
            "Provider": provider,
            "Category": oldName,
            "NewCategory": newName
        };
        await Vue.http.post(`/api/betconstruct/${clientId}/set/category`, settings).then(() => successHandler());
        noty.success("Category successfully renamed!");
    },
    getProviders(games) {
        return games.reduce((acc, game) => {
            if(!acc.providers[game.gameSourceProvider]){
                acc.providers[game.gameSourceProvider] = [];
            }
            if(acc.providers[game.gameSourceProvider].includes(game.category)) return acc;

            acc.providers[game.gameSourceProvider].push(game.category);
            if(acc.categories.includes(game.category)) return acc;

            acc.categories.push(game.category);
            return acc;
        }, {providers: {}, categories: []});
    },
    async changeParamForSelectedGames(clientId, filter, isEnable, successHandler){
        const data = {
            "Provider": filter.provider,
            "Category": filter.category,
            "Search": filter.search
        };
        await Vue.http.post(`/api/betconstruct/${clientId}/game/set/${filter.param}/${isEnable}`, data).then(() => successHandler());
        noty.success("Parameter successfully changed!");
    }
};


// WEBPACK FOOTER //
// ./src/services/betconstruct.service.js